// extracted by mini-css-extract-plugin
export var Nav = "NavItemStyles-module--Nav--1Rz5J";
export var NavLink = "NavItemStyles-module--NavLink--E_JEL";
export var NavItem = "NavItemStyles-module--NavItem--3dpz4";
export var MobileMenu = "NavItemStyles-module--MobileMenu--1y81Z";
export var MobileMenuActive = "NavItemStyles-module--MobileMenuActive--3AIZQ";